"use strict";
'use es6';

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = TimelineStickyControls;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _taggedTemplateLiteralLoose2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteralLoose"));

var _colors = require("HubStyleTokens/colors");

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireWildcard(require("react"));

var _reactDom = _interopRequireDefault(require("react-dom"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _SubjectContext = require("crm_ui/profile/SubjectContext");

var _TimelineControls = _interopRequireDefault(require("crm_ui/timeline/components/config/controls/TimelineControls"));

function _templateObject() {
  var data = (0, _taggedTemplateLiteralLoose2.default)(["\n  position: sticky;\n  top: 0;\n  min-height: ", "px;\n  z-index: 2;\n  background-color: ", ";\n  overflow: hidden;\n  border-bottom: 1px ", ";\n  border-bottom-style: ", ";\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

var CONTROLS_HEIGHT = 128;
var CONTROLS_HEIGHT_REDESIGN_NO_FILTERS = 68;
var NAV_HEIGHT = 60;

var StickyControlsWrapper = _styledComponents.default.div.withConfig({
  displayName: "TimelineStickyControls__StickyControlsWrapper",
  componentId: "sc-3sb4gi-0"
})(_templateObject(), function (_ref) {
  var useMiniControlsHeight = _ref.useMiniControlsHeight;
  return useMiniControlsHeight ? CONTROLS_HEIGHT_REDESIGN_NO_FILTERS : CONTROLS_HEIGHT;
}, _colors.GYPSUM, _colors.GREAT_WHITE, function (_ref2) {
  var showLine = _ref2.showLine;
  return showLine ? 'solid' : 'none';
});

var propTypes = {
  isUngatedForActionsRedesign: _propTypes.default.bool,
  isUngatedForStickyControls: _propTypes.default.bool,
  activityTabIsSelected: _propTypes.default.bool,
  isOptedInToActionsRedesign: _propTypes.default.bool
};

function TimelineStickyControls(_ref3) {
  var isUngatedForActionsRedesign = _ref3.isUngatedForActionsRedesign,
      isUngatedForStickyControls = _ref3.isUngatedForStickyControls,
      activityTabIsSelected = _ref3.activityTabIsSelected,
      isOptedInToActionsRedesign = _ref3.isOptedInToActionsRedesign,
      passThruProps = (0, _objectWithoutProperties2.default)(_ref3, ["isUngatedForActionsRedesign", "isUngatedForStickyControls", "activityTabIsSelected", "isOptedInToActionsRedesign"]);

  var _useState = (0, _react.useState)(false),
      _useState2 = (0, _slicedToArray2.default)(_useState, 2),
      shouldShowDividerLine = _useState2[0],
      setShouldShowDividerLine = _useState2[1];

  var _useContext = (0, _react.useContext)(_SubjectContext.SubjectContext),
      objectType = _useContext.objectType,
      subjectId = _useContext.subjectId;

  var controlsBaseRef = (0, _react.createRef)();

  function getIsAtTopOfTimeline() {
    if (!controlsBaseRef) {
      return true;
    }

    var controlsNode = _reactDom.default.findDOMNode(controlsBaseRef.current);

    if (!controlsNode) {
      return false;
    }

    return controlsNode.getBoundingClientRect().top === NAV_HEIGHT;
  }

  function onScroll() {
    if (!isUngatedForStickyControls) {
      return;
    }

    var isAtTopOfTimeline = getIsAtTopOfTimeline();

    if (!isAtTopOfTimeline && !shouldShowDividerLine) {
      setShouldShowDividerLine(true);
    } else if (isAtTopOfTimeline && shouldShowDividerLine) {
      setShouldShowDividerLine(false);
    }
  }

  (0, _react.useEffect)(function () {
    if (!window) {
      return function () {};
    }

    window.addEventListener('scroll', onScroll, true);
    return function cleanup() {
      window.removeEventListener('scroll', onScroll, true);
    };
  });

  function renderControls() {
    return _react.default.createElement(_TimelineControls.default, (0, _extends2.default)({}, passThruProps, {
      isUngatedForActionsRedesign: isUngatedForActionsRedesign,
      isUngatedForStickyControls: isUngatedForStickyControls,
      activityTabIsSelected: activityTabIsSelected,
      isOptedInToActionsRedesign: isOptedInToActionsRedesign,
      objectType: objectType,
      subjectId: subjectId
    }));
  }

  function renderStickyControls() {
    return _react.default.createElement(StickyControlsWrapper, {
      useMiniControlsHeight: isUngatedForActionsRedesign && isOptedInToActionsRedesign && !activityTabIsSelected,
      showLine: shouldShowDividerLine
    }, renderControls(true));
  }

  if (isUngatedForStickyControls) {
    return _react.default.createElement(_react.Fragment, null, _react.default.createElement("div", {
      ref: controlsBaseRef
    }), renderStickyControls());
  }

  return renderControls();
}

TimelineStickyControls.propTypes = propTypes;
module.exports = exports.default;